'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var Unlock = function Unlock(_ref) {
  var color = _ref.color,
      className = _ref.className,
      width = _ref.width,
      height = _ref.height,
      title = _ref.title;
  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-unlock ' + className, preserveAspectRatio: 'xMinYMin meet', width: width, height: height, viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement('path', { fill: color, className: 'path1', d: 'M12 1c1.654 0 3 1.346 3 3v3h-2v-3c0-0.551-0.449-1-1-1h-2c-0.551 0-1 0.449-1 1v3h0.25c0.412 0 0.75 0.338 0.75 0.75v7.5c0 0.412-0.338 0.75-0.75 0.75h-8.5c-0.412 0-0.75-0.338-0.75-0.75v-7.5c0-0.412 0.338-0.75 0.75-0.75h6.25v-3c0-1.654 1.346-3 3-3h2z' })
  );
};

Unlock.propTypes = _bcPropTypes.iconShape;

exports.default = Unlock;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Unlock/Unlock.js
// module id = 353
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16